
export default function ExperienceValue() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Heading */}
        <h2 className="text-5xl font-bold text-center mb-4 leading-tight text-[#1a1a2e]" style={{ fontFamily: 'Noto Serif JP, serif' }}>
          家具ではありません。<br />
          <span className="border-b-4 border-[#8E7CC3]">社員の"働き方"を設計する、生産性向上デバイスです。</span>
        </h2>

        <div className="h-20"></div>

        {/* 3 Step Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Step 1: ON */}
          <div className="bg-[#fafafa] rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 border border-[#e8e6e3]">
            <div className="w-16 h-16 bg-[#8E7CC3] rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-3xl font-bold text-white">1</span>
            </div>
            <h3 className="text-2xl font-bold text-center mb-6 text-[#1a1a2e]">【ON】座った瞬間、仕事モードへ</h3>

            {/* Core Block */}
            <div className="mb-6">
              <div className="bg-[#5a5a6e] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-3">
                Core
              </div>
              <ul className="space-y-2">
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#5a5a6e]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">標準アームレストで快適な姿勢をサポート</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#5a5a6e]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">一般的なデスクワークに最適化された設計</span>
                </li>
              </ul>
            </div>

            {/* Pro Block */}
            <div className="mb-6">
              <div className="bg-[#8E7CC3] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-3">
                Pro
              </div>
              <ul className="space-y-2">
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#8E7CC3]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">6Dアームレストが腕・肩・姿勢を立体的にサポート</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#8E7CC3]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">電動昇降デスクとの相性を最大化</span>
                </li>
              </ul>
            </div>

            {/* Style Block */}
            <div className="mb-6">
              <div className="bg-[#5a8a6a] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-3">
                Style
              </div>
              <ul className="space-y-2">
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#5a8a6a]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">バランスボール原理の座面が体幹を自然に刺激</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#5a8a6a]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">無意識の姿勢制御で、集中しやすい状態へ</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Step 2: FLOW */}
          <div className="bg-[#fafafa] rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 border border-[#e8e6e3]">
            <div className="w-16 h-16 bg-[#8E7CC3] rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-3xl font-bold text-white">2</span>
            </div>
            <h3 className="text-2xl font-bold text-center mb-6 text-[#1a1a2e]">【FLOW】集中が途切れない</h3>

            {/* Common Design */}
            <div className="mb-6 bg-white rounded-lg p-4 border border-[#e8e6e3]">
              <div className="text-xs font-bold text-[#1a1a2e] mb-2">共通設計思想</div>
              <ul className="space-y-2">
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#8E7CC3]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">身体の微細な動きに追従するフレーム構造</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#8E7CC3]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">長時間作業でも「固まらない」ため、思考が止まらない</span>
                </li>
              </ul>
            </div>

            {/* Core */}
            <div className="mb-4">
              <div className="bg-[#5a5a6e] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-2">
                Core
              </div>
              <p className="text-sm text-[#4a4a4a]">日常業務の快適性をリーズナブルに実現</p>
            </div>

            {/* Pro */}
            <div className="mb-4">
              <div className="bg-[#8E7CC3] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-2">
                Pro
              </div>
              <p className="text-sm text-[#4a4a4a]">高負荷・長時間業務でもパフォーマンスを維持</p>
            </div>

            {/* Style */}
            <div>
              <div className="bg-[#5a8a6a] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-2">
                Style
              </div>
              <p className="text-sm text-[#4a4a4a]">健康志向で集中力を底上げ</p>
            </div>
          </div>

          {/* Step 3: RESET */}
          <div className="bg-[#fafafa] rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 border border-[#e8e6e3]">
            <div className="w-16 h-16 bg-[#8E7CC3] rounded-full flex items-center justify-center mb-6 mx-auto">
              <span className="text-3xl font-bold text-white">3</span>
            </div>
            <h3 className="text-2xl font-bold text-center mb-6 text-[#1a1a2e]">【RESET】短時間で回復する</h3>

            {/* Common Features */}
            <div className="mb-6 bg-white rounded-lg p-4 border border-[#e8e6e3]">
              <div className="text-xs font-bold text-[#1a1a2e] mb-2">Core / Pro / Style 共通</div>
              <ul className="space-y-2">
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#8E7CC3]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">深く倒れるリクライニング設計</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-[#8E7CC3]"></i>
                  </div>
                  <span className="text-sm text-[#4a4a4a]">15分の休憩で脳と身体をリセット</span>
                </li>
              </ul>
            </div>

            <div className="bg-[#8E7CC3]/10 border-l-4 border-[#8E7CC3] p-4 rounded">
              <p className="text-sm font-bold text-[#1a1a2e]">→ 午後の生産性が大きく変わります</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
